import { render, staticRenderFns } from "./IOSSNumbersTable.vue?vue&type=template&id=32f2a42d&scoped=true"
import script from "./IOSSNumbersTable.vue?vue&type=script&lang=js"
export * from "./IOSSNumbersTable.vue?vue&type=script&lang=js"
import style0 from "./IOSSNumbersTable.vue?vue&type=style&index=0&id=32f2a42d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f2a42d",
  null
  
)

export default component.exports